var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrafts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5.5 0 61.432 61.432",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--text-color)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, "\n                  {\" \"}\n                  ", /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(-447.948 -926.141)"
  }, "\n                    {\" \"}\n                    ", /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M497.139,938.044h-5.417v-5a1.25,1.25,0,0,0-1.25-1.25h-4.746v-4.4a1.25,1.25,0,0,0-1.25-1.25H449.2a1.249,1.249,0,0,0-1.25,1.25v47.028a1.25,1.25,0,0,0,1.25,1.25h4.747v4.4a1.25,1.25,0,0,0,1.25,1.25h5.416v5a1.25,1.25,0,0,0,1.25,1.25h35.278a1.25,1.25,0,0,0,1.25-1.25V939.294A1.25,1.25,0,0,0,497.139,938.044Zm-46.691,35.125V928.641h32.778v3.15H455.2a1.25,1.25,0,0,0-1.25,1.25v40.128Zm6,5.651V934.291h32.777v3.753H461.861a1.25,1.25,0,0,0-1.25,1.25V978.82Zm39.444,6.253H463.111V940.544h32.778Z",
    fill: "var(--text-color)"
  }), "{\" \"}\n                    ", /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M466.993,968.634a1.25,1.25,0,0,0,0,2.5h25.014a1.25,1.25,0,0,0,0-2.5Z",
    fill: "var(--text-color)"
  }), "{\" \"}\n                    ", /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M492.007,973.444H466.993a1.25,1.25,0,0,0,0,2.5h25.014a1.25,1.25,0,0,0,0-2.5Z",
    fill: "var(--text-color)"
  }), "{\" \"}\n                    ", /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M492.007,978.256H466.993a1.25,1.25,0,0,0,0,2.5h25.014a1.25,1.25,0,0,0,0-2.5Z",
    fill: "var(--text-color)"
  }), "{\" \"}\n                    ", /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 25.015,
    height: 20.976,
    transform: "translate(466.993 943.975)",
    fill: "var(--text-color)"
  }), "{\" \"}\n                  "), "{\" \"}\n                ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafts);
export default __webpack_public_path__ + "static/media/drafts.dcddd4e691bacfd752d3a95774be0eee.svg";
export { ForwardRef as ReactComponent };